import React from "react";
import MainImg3 from "../../../assets/illustrations2/PNG/why_choose_exactmails.png";
import Line from "../../../assets/line2.svg";
import check from "../../../assets/check.svg";
// import { FaCheck } from "react-icons/fa";

export default function Context() {
  return (
    <>
      <div className="bg-[#f4f8ff] py-8 px-5 flex flex-col items-center pb-20">
        <div className="text-center w-full mb-8 mt-2 lg:mt-12  max-w-[1600px]">
          <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
            Why Our Email{" "}
            <span className="relative inline-block">
              Verification{" "}
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            Works
          </h2>
          <p className="text-xl md:text-2xl my-4 mt-6">
            We keep things simple but effective. Here's how we make sure you get
            the best results:
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center md:space-x-8 max-w-[1600px] w-full">
          <div className="w-full md:w-1/2 grid grid-cols-1 gap-5 text-2xl font-semibold mb-6">
            <ul className="space-y-5 text-xl md:text-2xl">
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                SMTP-CHECKUP
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Syntax Validation
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Domain Verification
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Catch-All Address Filtering
              </li>
            </ul>
          </div>

          <div className="w-full flex justify-center mb-8 md:mb-0">
            <img
              src={MainImg3}
              alt="Features Illustration"
              className="w-full max-w-lg"
            />
          </div>

          <div className="w-full md:w-1/2 grid grid-cols-1 gap-5 text-2xl font-semibold">
            <ul className="space-y-5 text-xl md:text-2xl">
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Mail-Server Validation
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Temporary Email Detection
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                MX-Record Check
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Anti-Spam Trap Identification
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
